<template>
    <div>
        <h2 class="van-doc-demo-block__title">云仓代发</h2>
        <van-notice-bar
            left-icon="volume-o"
            scrollable
            text="您尚未开通云仓代发服务，请联系客服开通。"
        />
        <van-notice-bar
                wrapable
                :scrollable="false"
                background="#ecf9ff"
                text="云仓代发：是为了解决 门店较小无备货空间 以及 连锁店总部下单分发至各门店 情景。您下单后仅需在公众号内填写地址和数量 我们为24小时内为您发货，发出的单号及剩余数量会实时通知您。当库存余量不足时也会提醒您备货。"
        />
        <span class="dk-message-text">

        </span>
    </div>
</template>

<script>
    import { NoticeBar } from 'vant';

    export default {
        name: "noPhone",
        components: {
            [NoticeBar.name]: NoticeBar,
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {

        }
    }
</script>

<style scoped>
    p{
        margin: 0.4em 0;
        font-size: 14px;
    }
    .dk-title {
        height: 49px;
        font-size: 16px;
        color: #333;
        background: #EEEEEE;
        padding: 0 15px;
    }

    .dk-title img {
        width: 4px;
        height: 16px;
        margin-right: 10px;
    }
    .dk-text {
        color: #646566;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    /deep/ .van-badge--dot{
        width: 10px;
        height: 10px;
    }
    .dk-text-warn{
        color: #D9001B;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-settle{
        color: #4994df;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-center{
        text-align: center;
    }
    .dk-record{
        height: 300px;
        overflow-y: auto;
    }
    .dk-record-title {
        display: flex;
        align-items: center;
        height: 28px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding: 0 0 0 0.85333em;
    }
    .dk-record-text {
        display: flex;
        align-items: center;
        height: 60px;
        font-size: 14px;
        color: #646566;
        padding: 0 0 0 0.85333em;
    }
    /deep/ .van-dialog__header {
        padding-top: 0.4rem;
    }
    /deep/ .van-divider{
        margin: 0.15rem 0;
    }
    .dk-title-divider{
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    .dk-title-divider-add{
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: #D9001B;
    }
    .dk-title-divider-settle{
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: #4994df;
    }
    .dk-message-text{
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #646566;
        padding: 0 0.85333em;
    }
    .van-doc-demo-block__title {
        margin: 0;
        padding: 20px 16px 16px;
        color: #323232;
        font-weight: 700;
        font-size: 17px;
        line-height: 16px;
        text-align: center;
        font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
    }
</style>
